import { LineageTreePage } from './tree'

export function TreePage() {
  return (
    <>
      <div style={{ border: '1px solid #000' }}>
        <LineageTreePage />
      </div>
    </>
  )
}
